// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2GbBS","icon":"SortAdornment_icon__3t9sp","up":"SortAdornment_up__1RlX6","down":"SortAdornment_down__1z_Sy","active":"SortAdornment_active__3cD11"};